<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M7.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zM6.5 9.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75zM7.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zM10 12.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75zm.75-4.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zM10 5.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75zM14.25 12a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5zm-.75-2.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1-.75-.75zM14.25 5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5z"
      fill="currentColor"
    ></path>
    <path
      fill-rule="evenodd"
      d="M3 20a2 2 0 0 0 2 2h3.75a.75.75 0 0 0 .75-.75V19h3v2.25c0 .414.336.75.75.75H17c.092 0 .183-.006.272-.018a.758.758 0 0 0 .166.018H21.5a2 2 0 0 0 2-2v-7.625a2 2 0 0 0-.8-1.6l-1-.75a.75.75 0 1 0-.9 1.2l1 .75a.5.5 0 0 1 .2.4V20a.5.5 0 0 1-.5.5h-2.563c.041-.16.063-.327.063-.5V3a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v17zm2 .5a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5h-3v-2.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v2.25H5z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'company',
}
</script>
